'use client'

import type { FC } from 'react'
import { createContext, useContext, useState } from 'react'

type MapSelectedVenueContextType = {
	selectedVenue: string | null
	setSelectedVenue: (venueId: string | null) => void
}

export const MapSelectedVenueContext = createContext<MapSelectedVenueContextType | null>(null)

export const MapSelectedVenueProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
	const [selectedVenue, setSelectedVenue] = useState<string | null>(null)

	return (
		<MapSelectedVenueContext.Provider value={{ selectedVenue, setSelectedVenue }}>
			{children}
		</MapSelectedVenueContext.Provider>
	)
}

export const useMapSelectedVenue = () => {
	const context = useContext(MapSelectedVenueContext)
	if (!context) {
		throw new Error('useMapSelectedVenue must be used within a MapSelectedVenueProvider')
	}
	return context
}
